import { IActionGroup, IStore } from '../index';
import { IErrorsStore } from './store';

export interface IErrorsActions extends IActionGroup {
  clear: () => { errors: IErrorsStore };
};

const actions: IActionGroup = {
  clear: (state: IStore) => {
    const errors: IErrorsStore = {};
    Object.keys(state.errors).forEach((key: string) => {
      errors[key] = {};
    });
    return { errors };
  }
};

export default actions;
